var _style, _g, _g2, _g3, _g4, _g5, _ellipse, _polygon, _polygon2, _ellipse2, _defs, _g6, _ellipse3, _polygon3, _polygon4, _ellipse4, _defs2, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChestUnlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 66",
    style: {
      enableBackground: "new 0 0 80 66"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.3;fill:#52656D;enable-background:new    ;}\r\n\t.st1{fill:#37464F;}\r\n\t.st2{fill:#5F7888;}\r\n\t.st3{fill:#6F8B9D;}\r\n\t.st4{fill:#4F6471;}\r\n\t.st5{fill:#C4C4C4;}\r\n\t.st6{fill:#375161;}\r\n\t.st7{fill:#293D49;}\r\n\t.st8{opacity:0.92;fill:#293D49;enable-background:new    ;}\r\n\t.st9{fill:#2A3E4A;}\r\n\t.st10{fill:#C77D07;}\r\n\t.st11{fill:#CD7D04;}\r\n\t.st12{fill:#FFC511;}\r\n\t.st13{fill:#FFC616;}\r\n\t.st14{fill:#FFC903;}\r\n\t.st15{fill:#FEF504;}\r\n\t.st16{fill:#EDAA04;}\r\n\t.st17{fill:#EFAD06;}\r\n\t.st18{fill:#C27703;}\r\n\t.st19{fill:#975900;}\r\n\t.st20{fill:#B66F03;}\r\n\t.st21{opacity:0.92;fill:#975900;enable-background:new    ;}\r\n\t.st22{opacity:0.92;fill:#B66F03;enable-background:new    ;}\r\n\t.st23{fill:#BE740B;}\r\n\t.st24{opacity:0.3;fill:#AFAFAF;enable-background:new    ;}\r\n\t.st25{fill:#CE7D03;}\r\n\t.st26{fill:#EEAB00;}\r\n\t.st27{fill:#B46C00;}\r\n\t.st28{fill:#724500;}\r\n\t.st29{fill:#FEC700;}\r\n\t.st30{fill:#FEF400;}\r\n\t.st31{opacity:0.3;fill:#CE7D03;enable-background:new    ;}\r\n\t.st32{fill:#BF7402;}\r\n\t.st33{fill:#2C383F;}\r\n\t.st34{opacity:0.2;}\r\n\t.st35{clip-path:url(#SVGID_2_);}\r\n\t.st36{fill:#FFFFFF;}\r\n\t.st37{fill:#168DC5;}\r\n\t.st38{fill:#1CB0F6;}\r\n\t.st39{clip-path:url(#SVGID_4_);}\r\n")), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 425,
    height: 431,
    id: "XMLID_2_",
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAiwAAAQWgAAHov/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAbABqgMBIgACEQEDEQH/ xADPAAEAAwEBAQEAAAAAAAAAAAAAAgMEBQEGBwEBAQADAQEAAAAAAAAAAAAAAAECBAUDBhAAAQQB AwMCBgEEAwEAAAAAAgABAwQFQBEUMBI1EBMgUCExMwYiYDIVFnAjNCURAAECAgYHBQYFBAMBAAAA AAEAAhEDITHRkgQ0EEBBURKyc2FxIjKEIDCBkbETUKHBQlLwYnIjMxQFghIAAQMCBQEFBgQHAAAA AAAAAQARAiESQDFBUQMQYXGBIjJgkaFighNwsVKS8MHRQnIEFP/aAAwDAQACEQMRAAAA+ey2ZMsL 1AvUC9QL1AvUC9QL1AvUC9QL1AvUC9QL1AvUC9QL1AvUC9QL1AvUC9QL1AvUC9QL1Av28vcQya8g AAAAAAAAAAAAAAAAAAAAAAAAA3YdxDJryAAAAAAAAAAkRWipaKloqWipKIAAAAAAAAAA3YdxDJry AAAAAAAAAC2uZWltywwOjXljiabpcDpc6W2m2rHMAAAAAAAAABuw7iGTXkAAAAAAAAAPZwmO3wJe njv08ZZ3a+Myx6PN988va2q2rHMAAAAAAAAABuw7iGTXkAAAAAAAAAF1NxS6Wasy+xMjXUUtWhcd NtUAAAAAAAAAAN2HcQya8gAAAAAAAABLfVCyPY09De5kPZW7WlTDRWcTlfYczV3uXz9Puj08ggAA AAAAAABuw7iGTXkAAAAAAAAHvkzfD2718foh1eFq7tXY53Y5XD+x4dx4I6HK+UslHk93nPfPP1AA AAAAAAAbsO4hk15AAAAAAAABKI6Mo0enl9cz6Orw9303xvuvtfZfKUeVHz3N76vAlnu5PdweGHoA AAAAAAAA3YdxDJryAAAAAAAAAGi3FurR1/npbOl9LPj6NvR6EMWc38ahqb/tF2LW3AgAAAAAAAAB uw7iGTXkAAAAAAAAAHvg13c6VaIezK5+wNNGeIEAAAAAAAAAAN2HcQya8gAAAAAAAPTxptMLfGsS +iAAAAAAAAAAAAAAG7DuIZNeQAAAAAAAnuhbYej1tmc6jdnOY0Z5QAAAAAAAAAAAAG7DuIZNeQAA AAAAA6ZKzZXoglN2S1ZZJwKcW3EoQAAAAAAAAAAAA3YdxDJryAAAAAAAG63FprbPGS2oDyorzSjK AAAAAAAAAAAAA3YdxDJryAAAAAAAC6kbJYpGzzLGtOeCAAAAAAAGrofZa2z8U+yjpbXx762+PgsP 6d8tu6/zQ2tQABuw7iGTXkAAAAAAACYg98AAAAAAAAAP0DQlw+zSOdstFst7whXfHZw/L/LK+txw AG7DuIZNeQAAAAAGk80y22YnQqMlPXwnLj0efL4AAAAAA7HNKfofnt8v6PLy7S6OSe+EZ2ifpjkh fVhn838X1uTu84LiA3YdxDJryAAAAAHvRwdCruryurcZxlElh3YTn5dWeXIJQAAAAOh3vkfqpfnd /wCjfM3H6K+mevu6uH0efljbu5nQLKpeeft+dcj6H57d5AYe4Ddh3EMmvIAAAAAS6HN21r2831Op 7y52b8+RL5mvxrUIAAAAAdXlD9Xw/E/X56/T0cnZMtVE5avSrujAtohm3OTHhdfqZef55zPsPj9f ohlg3YdxDJryAAAAACysbbMF1avc/pdCqoszEAAAAAAAOnzJn2/R+T7nQ4vTnil5926MYz2t57h+ /wAzzp4q+Z3gsAbsO4hk15AAAAAAAAAAAAAAAAABfRYbPtPkPrsvT2vfj9uzL2G2zJ8V9b8vr8bF nvomAADdh3EMmvIAAAAAAAHuwzW6lmeGsc6PTyrmEAAAAAAbuhwbj9X2/kGyZfpOH4LJcuhlzUPM AABuw7iGTXkAAAAAAANl/ntiV1pDLvrMiysxU7cUoAAAAAAAAAAAADdh3EMmvIAAAAAAPfB00J2W a8Ww9j54mXwWnFqyygAAAAAAAAAAAAN2HcQya8gAAAAAABo08/RWr2mSTlV4WVxoWNZAAAAAAAAA AAAADdh3EMnRylC8ULxQvFC8ULxQvFC8ULxXP0IyFUbxQvFC8ULxQvFC8ULxQvFC8ULxQvFC8ULx QvFC8UbqNp//2gAIAQIAAQUA/pwQJ29o00ZOxAQ6iORhYZe1e/8AQi7tTs+2ztqYKzMz9rN9Haes 22mhZnlVmaXetNLupWZpNLGXabPupq/unDXeI3fZjfuPTRWO1DKzopmZTWO75lt84f57PaaNyyjs 0eTM3htd76e6xdqhrdqZvrpnZyb223apEL+0yIGQi4t0W6bvs0B90hNsbm2zG2227yM7HpNmdB2R lLXI08RsmiN1BUJntSB2A7u2lFwaNyJ3EzYu4WDZt9MBuKEn7f4ixG5anZO7u39Y/wD/2gAIAQMA AQUA/pwpBF/fjTygxBIJ6iWJzc4O5NW+oB26nuZnYmd9RZuE7t3ET9wlWuFvprBOMKp14drleFmU BOUWlmHujdnZ69toYrFtpoxF3eIe2PTT1O5ygJkMBEoKvY//ABNBWeRmoAioRspqva2ng2ZkUm6d /p1N1v0N0xiDse48h3TyszsTozE36T9IRcivRMFaF+6FoX7nhfu+w1iYoenstuhu7KZprAVrwQIL MJMdmEWvZUCDF15mlkEWLSbI60stiDBQRDYwdWQGqSDMzuw6VlC4BNCTmJjEAyOJTPqGJ2RSkQ/1 j//aAAgBAQABBQDKXbg5PnXVzrq511c66uddXOurnXVzrq511c66uddXOurnXVzrq511c66uddXO urnXVzrq511c66uddXOurnXVzrq511c66uddXOurnXVzrq511c66uddXOurnXVzrq511c66uddXO urnXVzrq511c66uddXOurnXVzrq511c66ubcWV8p81yvlPmuV8p81yvlPmuV8ppAjI1xzXHNcc1x zXHNcc1xzXHNEBBqMr5TRt95icX6ETubafK+U0bfex+aMCkOfGDCMWLilhq44rU9akc9ubGMELYq F4TZhOv+XT5Xymjb72PzV+/35IWmCi7NjKHtVsewRhm5pIXx0bt/hFX/AC6fK+U0bfex+ZPIbtu7 M7u7d5ruJm3fZV/y6fK+U0bKYXPoxM8bafK+U0lcZCJxBmksAyCWY3mqTe3HUnGMpZgeOxGS7Rdp xkEtPlfKaOMHkJmGMCKWzJSwAC0cMMTGAmIiIDLXhma9gB2jkkgMwGUDFwLTZXymjqx9oWpHIsVj hqQ+latNalnglry+mYxw2Iqsitx7jpsr5TRM27/QAxELWMh6Q4u9OOHxp0wzOMktqfG3YA9MhFxc iYsQabK+U0UX5Zvxfrv/AKvTD5UJR9M1lQYfTP8A/vD6gf0PS5XymijfY5G3jwR9lr7+mGj9zIz2 YK4w2IbAZSP276d2Zs0ffeFu0CfctLlfKaOIu+OvJxbsEzbKOWSI5ZpZiinmgIzOQ1YnbYz5Nyc+ yPTZXymjqSbPYi7xxuQbYJiBDYB00gOnkBkVgGUkpEslfY1BF7YWpO4tNlfKaNndngmaRp6/cq+S nrqLJ1JGaeEkViAVLlKsbWMhYtPBXYFYnYG0+V8ppGd2eK0zogjkYqbJ6kqapKhpshEI2ltMnd3f T5XymmCUwQ3CZcwVzBRWzdFIZ6rK+U+a5XymgESJwpumrRMvYhRVYnUlUx+QZXynXjjeQo4xjb0E DJmjN07bKeBjZ2dn1uV8p168fZGmF3W2yqe2QgwMdqNmJW49i1uV8p1m+7NsyqAIq1D/ACiB42Ux iwK03/Trcr5TrN92fdo3YTIgeNTd7HFOPbKbGatP/wBWtyvlOvEe7KGVu1po95zEn9HfZrJ7trcr 5TrwybIT2TOz/A5MyM1IfeWtyvlNBHNsmJnXcS7yTk7opBFSSOegq4u9cZv1fLr/AFfLL/V8sv8A V8urOFyVUejlfKaFndk00jL35E8hvof13DjflEY4gedHI5Ld2URuTOzO37LhI4g6GV8p8lwNdocT O/8AP0ZndQxuLbKzCM1cmcX+PK+U633TRSOvZlZOJNpMW3/zrAOxJm3eMO0dlsjb+E/0n+PK+U6s VVyQxgHq7M6kqgSMCB9B+nUatq64szvAJC+PHeOmAL2mXtMvaZOP1/c8fTGl8eV8p1K0O/pXoNLG eMbaGhJI/wDjAUsRRSSRjIJC4l1MVgwv1rVaWpOsKdsciO7iyGnITSwnEooTlR1JBZOy/YbuQnvf HlfKdMW3IWYWrMznD+JB6W2Z3VwNi6mIyh0JstQjyVR8feYP1hm/ysbbhDs0l/IV6VTAZ+zlY87m yxVDBZQsjjZtvdJl+0MzZb48r5Tpw/lVb++H8SD0t/dXP7Or+klJLNsztPjI6n7FA+8SsQwWIKeP q4qvcx9XKwRRQQQIvo37VRmaz8eV8p04/oYvu1cmYwnIGayW72Nm5JqY2cFbLdur+u5N8dkeZB2z z+6dSVnD0AJOySOT2/SzKzDLGEof6S8pZjA28S/w5XynTb6PFJ9GfdbuhMhc5zJt3W6MtlOW5dbH 525VcSExiJ2cLbsmsROvdjXuxp7ETI7TuiJ2bGXYsnGJw1h/ccrUlrfDlfKdSKTscSTSMu4Vuycx ZPI7qWVhbQUM9aphj8jHOKCIzaZ6o1gNniYmf0yF8AjoZOxjbuazM2Xn+LK+U6oSECGcXTGLruFP KDI53dffQxB3lXlEwxHudtm2Vh2YWCOUo0z7PmY7ESnnGNpxYZPjyvlPklZ/qBkBUhEsKUYuzsUS Ymce7+OW2D9fIiMrTbP8eV8p8krn2S9o7/qM0VipZoWIHkchEA7VSonZf9xtxsu0d7Z90vx5Xymh CCQ01NcMUVMmRxmGgrWGJqN2ajZxmbpZKMoYSVzHjM+V/YKWMhnmksS2LDRs7u7/AB5XynXEXJ4a 4h8LsztPW20AWpQQ5CUXi/aMvEM37HlLDc80duUk7u79DK+U69WLYfSMe8pYhcPWzH2Hrcr5TrN9 xbYVHALiEYB6PBG6mjaN1bbeLW5XynWb7t9lFK4P6SH2CROTq1+HW5XynXiLdlG25u7MwzRk8zbx +lotx1uV8p14D3YTZ/RyIvRzJ232RHupj7i1uV8p12d2eOViTE7L3HXuJ5HTkpJt9flfKaEZTFNY XIZPYdEZF8gylK4WT4N1cG6uDdXBurg3Vwbq4N1cG6uDdXBurg3Vwbq4N1cG6uDdXBurg3Vwbq4N 1cG6uDdXBurg3Vwbq4N1cG6uDdXBurg3Vwbq4N1cG6uDdXBurg3Vwbq4N1cG6uDdXBurg3Vwbq4N 1cG6uDdXBurg3Vwbq4N1cG6uDdXBurhXF//aAAgBAgIGPwD2cJAoEKerKqJAoP5IPr24ggi59NEK OYxMR4lECLXGR/dso/LG3EuycjEiUw5OmyLsAPctCD7kZcYYjTDwB36HjkBEdmoQ44gSA+A6TA/U cNGWx6CRk0QGbVEiTxIbt6SlucPbLwKoQVUgK2OWp/Ce0VIzfIKlsvBWmMQVbMMTkRiJH569BIly 2WyGHYZlSEg9WVw4wE9qDBMc8K6iG1Uv8ii+yDbLxRfC1Qlxu7Vu0X3OMerOPb2KsZDwVIyPghPk o1RFC0gyfTZOcMJDJvigfS1VJ2Z6K8mifXDs/ld2RJIOfp2ROQz96Z6O7YoA6e2X/9oACAEDAgY/ APZwAmpUi7WepwQyESalvjkjacs6EYgEG1tdVLzMJzEzTYMyiTJ7REd9p1UqvdK7EsSHTAjEmHEb Yj+4ZlBnMiabui7iQPi6EOUuDQS1Hfh5kfp6R5YEzLa6HuUuWUjGR21Pd0gTmYjDTjvHoYiLyMnc 5KMTG2UZO+iZQjtEYcyhrnH+irGQVIyKEp5jKP4T3SLDRsys5e9O8ldAuBmDiIj5R0YYi+XpjUqM o6gFW3umMlVXRyIwoA1XJJ6WHNcfbxx/JRbdF913BQILsGPfhXBY6FS4v9m0REgYnio/e6/5uct9 ukOTQx0fuXl5OM/UF5uTjH1BHi4DdfSU8g3YpXwlHitrdQE6MiI5YY8YeXJKTVQ++Zc0ptEiIoP4 3RHHH7MojySiX/cCvtSHnjJmVr0w8eUisaPqxTmUJVLGO2j9qeVIiV/1ZqfKAxn+WJpRCJNI5e2X /9oACAEBAQY/AMY1uImACfNAAe6AHGe1ZibfdasxNvutWYm33WrMTb7rVmJt91qzE2+61Zibfdas xNvutWYm33WrMTb7rVmJt91qzE2+61ZibfdasxNvutWYm33WrMTb7rVmJt91qzE2+61ZibfdasxN vutWYm33WrMTb7rVmJt91qzE2+61ZibfdasxNvutWYm33WrMTb7rVmJt91qzE2+61ZibfdasxNvu tWYm33WrMTb7rVmJt91qzE2+61ZibfdasxNvutWYm33WrMTb7rVmJt91qzE2+61ZibfdasxNvutW Ym33WrMTb7rVmJt91qzE2+61ZibfdasxNvutWYm33WrMTb7rV/zzMtHzur+axvXm87vxX0qxvXm8 7vxX0qxvXm87vxX0qxvXm87vxX0qxvXm87tV8Io3qtvzVbfmq2/NVt+arb81W35qtvzVbfmvENX9 Ksb15vO7VftNoDa+0+5Mp1IIiOwjV/SrG9ebzu1QJ39bE2W2lzjAd5T4z2GZLEXS9qM4YlvCwAvo PhipkqU8FksR+5sK/wCqTwOHECT/AGp86VObNbLMJkP2ozxim/bBgXQNac0HiAJAO9DuP01f0qxv Xm87tUCd/WxS/tkNfxDhJqBU12OkslkNiJzTWVjQTSeH9UHvmiS+c8ODjuaakycwgy5zHPB/+SsQ cI3gJfCcCYmEawpojT9wUfLQO4/TV/SrG9ebzu1QJ39bNEC4kbiUQDQawgCaBUEDxGIqpRAJga1C NG7QO4/TV/SrG9ebzu1X7raQa+w+5Mx1FEGjeTq/pVjevN53ar4TBu0qJA71CW0HtgoMYHHsbFfd MssO0EL7olF5NUBEBQc0NPa2Cg9oB3woVAHYYLxmI2HV/SrG9ebzu1QNChUAhLlgmNTRtQfijxO/ gKh3qEtgaBuC4XiIOwoNaIAVAKE1gcDvCMzCGBr+2f0RlzQRCgg1hQNRqKLTWNW9Ksb15vO7VOI1 u+iEpvx70HvEZzxFx3DdpEqSIuNPYjKmjhe2saTOliE5gj/kNy+27ZUg8Vig6t6VY3rzed2pgb12 NCaXUhsXn4VaQ9ko8LqiaE584D7r6KKYBMmyAPutocDREIvmSiGCt1Y0vDaGx4h3FEbxq3pVjevN 53am3vCd3KZ0/wBRpZhZvhmNHCw7HAaX4OT4iaJjt3ZpH+DfqU3uCcO06r6VY3rzed2ptO4pw3hO O9v6hR0Sv7Yu+QiuKc8MHbWuOS8Pb2Kc3ZxR+dOiJqCj/aB9UBuCJ3nVfSrG9ebzu1QHeKUHHyxg e4oNJo2HQJktxa8VELjmuL3HaVxSnljt4KL3kuc6snQQDBopJTpn7Yx+ATjtqGrelWN683ndqn2z UalxDzBCROMCKGOP0W8blTQqCFS4KilUmA3L/ryDEHzOG3sVPmNa4BU2vv1b0qxvXm87tUiK1A+Y VriZQ7aFwTBxtGw1hUu4DucqJjfmFEzGj4rwnjO5q4GeFh2D9VxOpd9Fwt8x/LV/SrG9ebzu1WIo IUJlB3qkR7V4XfNUQKpgF4jHuVEAN64ZfzUTXq/pVjevN53av4TDsXiEV5SvKV4QAvEY6z6VY3rz ed34r6VY3rzed2owaIlReYdgVUe9eUKiIUW+Ia/6VY3rzed2ocI+JUGj46YgRCoFSgVxNod9VA16 76VY3rzed2oA7XUnRQIqlcLt0PioO8qLm0jQHjbXrvpVjevN53e/ChoAmCEVFlMDBEuMI7NBBrOz QewjXfSrG9ebzu9+FFAmpNgPENBDjHcoOMCFEVVaCO7XfSrG9ebzu1Abjo4XGBFShH4ocNMNumKh v130qxvXm87tQ4T8FAqj2YmgBR2bNd9Ksb15vO7UYO+aiCq9FapPwW4btQjh5LnN/lU35ryNvBeR t4LyMvBeRt4IumyHcArc2kfl7n0qxvXm87tSoMFXopOomfPEcPKNX8nbkGtAYxtAAoCoCooGimsK BpB2I47Ct4Wx/wBzBVT+4e49Ksb15vO78Gw7QIFzeN3aXGxQ2DTQoms6Jsp4i17SCO8ItNYMD7fp VjevN53ahQ0rylUgjVMN02/RcWw6IBAbdLu4qZ/k76+36VY3rzed3vuJ9A3bV4RppEVFvhP5KDhq Mx+IaHmS3iYw1RJhGCgBACoBQdSCqHEKMYneq1Wq1BNxbWtlz2uDYgQ4gdnt+lWN683nd737jvgN Ae9xbGoBeB9PajxnhAoXnPyTmHYa1A17Ci01j3rp75hZSWtApq3p0iaIOaa9436JIwjzLmOMC4fx 2xQJrIpQUSQ3sXiq3rw1b1EEO7NBUyRi38TZLj9toEGwNRh3e36VY3rzed3vAN6AFQR7Am6DomR/ qjQHb6D72DqZDz427u0IYjDwdNaOKW4fuG5fcMiZwDbwlMjWGu+ib3JpNQKfiJswNa0UGvxGqhYi Tig0vlAOa9ohERhUpYw7gMVMMWtI4gWg+IpmKngMmRLXQqJG1OLao6Hw2taT+ft+lWN683nd7xne NB7k3QdEzu/TQ3v99OlPPFJlt4mtOxxMFAijcmYiQzhlTZbnPAHha6r8009mgyZrQ5jhBwKmOwnE 504+J7tgBoAUt2L4mukE8Lm7QawU2TIaGMbUBoKGNaOKUQGuI/aRv9v0qxvXm87veN71FGO0KAIg qYELwj5qsJxJpOgDcffMef8Aim/65vcTX8FxB0dq4qhUEGE0irTQYAk+EjtRi6gftA08ArNadLmN DmOoIKc+TiAyWT4WuBJCaZpEyU+hsxtUdx9n0qxvXm87veRQOwqhVqIKhV3KvRAVqG737ZbnccmI BDqSB2FBzTFrhEHsKoUHiPaq4d68wXmCrj3KDBDtRcaYUpz5FDmGExhrabEGzJjWE0+IgfVMwUl7 ZswuDnFpiGgdvs+lWN683nd72BqKiDQqVWq9FFCgPNqIlECbLFQdWO4ofcAY9wBG6kR0RA8IrcaA pYY4OnRPGW0hP/18R/n/AB0ulSjF5ECRsRxMgxpIcw1ObGopkyYwS2ywQxo7a6fa9Ksb15vO731F W5U0KghVhVqDaO3UhuFaAbQWiBCdiJ8wjDSzANP73fxCDOKDCfKKAAqK9icG1OECCoqXNY8nDzhQ BRBwraoGlxRhUaR7fpVjevN53fgpbvpQLTArDTAKC5/F/kqQIFRFLNo3IQq3qH5pz3+YTQZY/Iou cYkpvbH2/SrG9ebzu/BWk1VH4qMFP/8AOm1g/cZvgaDDuRoL2bHBUNidyO47Ny4j4ZYMCVI/86TV K8bwNhqCjBQFTaPb9Ksb15vO7UqBAbyqXfJeYrwkFeIQ1AMeYOFR3pmJkmD2GrYRtBQLHhk6HjlO MCD2b14mNPwTDL4WBvmo2IycKWzMRCDWt8rTvcU+dNdxTHmLid6gKXn8lE1+36VY3rzed2oACklR dS72YERCLmVbRqEI8Q7VxNHCRUQSCuGXPe0buKP1UJ057hu4iPovKPmoDwjsUTX7j0qxvXm87tQ4 zWau7SB814RAir2Ijyu130qxvXm87tQA3DQCTWvCNEYQQga9Edx130qxvXm87vfjTA0t0xUTXoPe Nd9Ksb15vO7UPpoaO1RJgoAo/PTDXfSrG9ebzu1Dh2ipU16KTHRAmjdogKlAVDXfSrG9ebzu1CIr UDQdFSq0RJXC2rfr3pVjevN53alXEdqpCqVAVJ1/0qxjm4eYQZ80ghjoEcZ7Fl5tx1iy8246xZeb cdYsvNuOsWXm3HWLLzbjrFl5tx1iy8246xZebcdYsvNuOsWXm3HWLLzbjrFl5tx1iy8246xZebcd YsvNuOsWXm3HWLLzbjrFl5tx1iy8246xZebcdYsvNuOsWXm3HWLLzbjrFl5tx1iy8246xZebcdYs vNuOsWXm3HWLLzbjrFl5tx1iy8246xZebcdYsvNuOsWXm3HWLLzbjrFl5tx1iy8246xZebcdYsvN uOsWXm3HWLLzbjrFl5tx1iy8246xZebcdYsvNuOsWXm3HWLLzbjrFl5tx1iy8246xZebcdYsvNuO sX/BMy0PI6v5L//Z",
    transform: "matrix(1 0 0 1 160.3618 -382.3057)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_146_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_43_",
    className: "st0",
    d: "M-186-99.6h72c2.2,0,4,1.8,4,4v32c0,2.2-1.8,4-4,4h-72c-2.2,0-4-1.8-4-4v-32 C-190-97.8-188.2-99.6-186-99.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_42_",
    className: "st1",
    d: "M-181.6-97.9c0-5.5,4.5-10,10-10h42.4c5.5,0,10,4.5,10,10v26.6c0,2.2-1.8,4-4,4h-54.5 c-2.2,0-4-1.8-4-4V-97.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_41_",
    className: "st1",
    d: "M-183.7-112.4c0-5.5,4.5-10,10-10h47.1c5.5,0,10,4.5,10,10v29.8h-67.2V-112.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_40_",
    x: -186.7,
    y: -94.8,
    className: "st2",
    width: 73.8,
    height: 11.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_39_",
    className: "st2",
    d: "M-122.8-112.1h7.9c1.1,0,2,0.9,2,2v18.3h-9.9V-112.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_38_",
    className: "st2",
    d: "M-186.7-110.1c0-1.1,0.9-2,2-2h6.4c1.1,0,2,0.9,2,2v16.3c0,1.1-0.9,2-2,2h-6.4 c-1.1,0-2-0.9-2-2V-110.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_37_",
    className: "st2",
    d: "M-183.7-123.6c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v20.5h-14.5V-123.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_36_",
    className: "st2",
    d: "M-131.1-123.6c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v20.5h-14.5V-123.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_35_",
    className: "st3",
    d: "M-183.6-113.5l14.3-3.6v12.6l-14.3-0.2V-113.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_34_",
    className: "st4",
    d: "M-183.7-105.9h14.5v14.5h-14.5V-105.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_33_",
    className: "st4",
    d: "M-183.7-85.1c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v17.8c0,1.1-0.9,2-2,2h-10.5 c-1.1,0-2-0.9-2-2V-85.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_32_",
    className: "st4",
    d: "M-132.4-85.1c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v17.8c0,1.1-0.9,2-2,2h-10.5 c-1.1,0-2-0.9-2-2V-85.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_31_",
    x: -131.1,
    y: -105.9,
    className: "st4",
    width: 14.5,
    height: 14.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_30_",
    x: -152.9,
    y: -87.7,
    className: "st5",
    width: 5.5,
    height: 9.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_29_",
    x: -183.7,
    y: -82.3,
    className: "st6",
    width: 14.5,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_28_",
    x: -132.4,
    y: -82.3,
    className: "st6",
    width: 14.5,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_27_",
    x: -169.2,
    y: -73.8,
    className: "st7",
    width: 36.8,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_26_",
    x: -169.2,
    y: -114,
    className: "st7",
    width: 38.1,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_25_",
    x: -169.2,
    y: -82.3,
    className: "st8",
    width: 36.8,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_24_",
    x: -169.2,
    y: -102.3,
    className: "st8",
    width: 38.1,
    height: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_22_",
    className: "st4",
    d: "M-186.7-91.4h73.8v9.1c0,1.1-0.9,2-2,2h-69.8c-1.1,0-2-0.9-2-2V-91.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "st2",
    d: "M-157.9-99.2h14.9c1.7,0,3,1.3,3,3V-84c0,1.7-1.3,3-3,3h-14.9c-1.7,0-3-1.3-3-3v-12.2 C-160.9-97.9-159.6-99.2-157.9-99.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    className: "st3",
    d: "M-156.2-99.2h-1.7c-1.7,0-3,1.3-3,3V-84c0,1.7,1.3,3,3,3h1c0.5,0,0.9-0.4,0.9-1l-0.3-12.7 V-99.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    className: "st4",
    d: "M-157.9-94.7h14.9c1.7,0,3,1.3,3,3v11.9c0,1.7-1.3,3-3,3h-14.9c-1.7,0-3-1.3-3-3v-11.9 C-160.9-93.4-159.6-94.7-157.9-94.7z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_11_",
    className: "st9",
    cx: -150.8,
    cy: -87.9,
    rx: 3.9,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st9",
    d: "M-151.7-86c0.4-0.7,1.4-0.7,1.8,0l1.8,3.6c0.3,0.7-0.2,1.5-0.9,1.5h-3.6 c-0.7,0-1.2-0.8-0.9-1.5L-151.7-86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st3",
    d: "M-131.1-121.2l14.5-3.5v8l-14.5,3.5V-121.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_8_",
    x: -169.4,
    y: -95.2,
    className: "st3",
    width: 8.4,
    height: 3.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_280_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_308_",
    className: "st0",
    d: "M2-61.6h72c2.2,0,4,1.8,4,4v32c0,2.2-1.8,4-4,4H2c-2.2,0-4-1.8-4-4v-32 C-2-59.8-0.2-61.6,2-61.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_307_",
    className: "st1",
    d: "M6.4-59.8c0-5.5,4.5-10,10-10h42.4c5.5,0,10,4.5,10,10v26.6c0,2.2-1.8,4-4,4H10.5 c-2.2,0-4-1.8-4-4V-59.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_306_",
    className: "st1",
    d: "M4.3-74.4c0-5.5,4.5-10,10-10h47.1c5.5,0,10,4.5,10,10v29.8H4.3V-74.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_305_",
    x: 1.3,
    y: -56.8,
    className: "st2",
    width: 73.8,
    height: 11.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_304_",
    className: "st2",
    d: "M65.2-74.1h7.9c1.1,0,2,0.9,2,2v18.3h-9.9V-74.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_303_",
    className: "st2",
    d: "M1.3-72.1c0-1.1,0.9-2,2-2h6.4c1.1,0,2,0.9,2,2v16.3c0,1.1-0.9,2-2,2H3.3c-1.1,0-2-0.9-2-2 V-72.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_302_",
    className: "st2",
    d: "M4.3-85.6c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v20.5H4.3V-85.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_301_",
    className: "st2",
    d: "M56.9-85.6c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v20.5H56.9V-85.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_300_",
    className: "st3",
    d: "M4.4-75.4L18.8-79v12.6L4.4-66.5V-75.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_299_",
    className: "st4",
    d: "M4.3-67.9h14.5v14.5H4.3V-67.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_298_",
    className: "st4",
    d: "M4.3-47c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v17.8c0,1.1-0.9,2-2,2H6.3c-1.1,0-2-0.9-2-2V-47 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_297_",
    className: "st4",
    d: "M55.6-47c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v17.8c0,1.1-0.9,2-2,2H57.6c-1.1,0-2-0.9-2-2 V-47z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_296_",
    x: 56.9,
    y: -67.9,
    className: "st4",
    width: 14.5,
    height: 14.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_295_",
    x: 35.1,
    y: -49.7,
    className: "st5",
    width: 5.5,
    height: 9.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_294_",
    x: 4.3,
    y: -44.3,
    className: "st6",
    width: 14.5,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_293_",
    x: 55.6,
    y: -44.3,
    className: "st6",
    width: 14.5,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_292_",
    x: 18.8,
    y: -35.8,
    className: "st7",
    width: 36.8,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_291_",
    x: 18.8,
    y: -75.9,
    className: "st7",
    width: 38.1,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_290_",
    x: 18.8,
    y: -44.3,
    className: "st8",
    width: 36.8,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_289_",
    x: 18.8,
    y: -64.3,
    className: "st8",
    width: 38.1,
    height: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_288_",
    className: "st4",
    d: "M1.3-53.4h73.8v9.1c0,1.1-0.9,2-2,2H3.3c-1.1,0-2-0.9-2-2V-53.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_287_",
    className: "st2",
    d: "M30.1-61.2H45c1.7,0,3,1.3,3,3V-46c0,1.7-1.3,3-3,3H30.1c-1.7,0-3-1.3-3-3v-12.2 C27.1-59.9,28.4-61.2,30.1-61.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_286_",
    className: "st3",
    d: "M31.8-61.2h-1.7c-1.7,0-3,1.3-3,3V-46c0,1.7,1.3,3,3,3h1c0.5,0,0.9-0.4,0.9-1l-0.3-12.7V-61.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_285_",
    className: "st4",
    d: "M30.1-56.7H45c1.7,0,3,1.3,3,3v11.9c0,1.7-1.3,3-3,3H30.1c-1.7,0-3-1.3-3-3v-11.9 C27.1-55.4,28.4-56.7,30.1-56.7z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_284_",
    className: "st9",
    cx: 37.2,
    cy: -49.9,
    rx: 3.9,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_283_",
    className: "st9",
    d: "M36.3-48c0.4-0.7,1.4-0.7,1.8,0l1.8,3.6c0.3,0.7-0.2,1.5-0.9,1.5h-3.6c-0.7,0-1.2-0.8-0.9-1.5 L36.3-48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_282_",
    className: "st3",
    d: "M56.9-83.2l14.5-3.5v8l-14.5,3.5V-83.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_281_",
    x: 18.6,
    y: -57.2,
    className: "st3",
    width: 8.4,
    height: 3.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_145_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_72_",
    className: "st0",
    d: "M-184.6,16.7h72c2.2,0,4,1.8,4,4v32c0,2.2-1.8,4-4,4h-72c-2.2,0-4-1.8-4-4v-32 C-188.6,18.5-186.8,16.7-184.6,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_71_",
    className: "st10",
    d: "M-180.2,18.4c0-5.5,4.5-10,10-10h42.4c5.5,0,10,4.5,10,10V45c0,2.2-1.8,4-4,4h-54.5 c-2.2,0-4-1.8-4-4V18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_70_",
    className: "st11",
    d: "M-182.4,3.9c0-5.5,4.5-10,10-10h47.1c5.5,0,10,4.5,10,10v29.8h-67.2V3.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_69_",
    x: -185.4,
    y: 21.5,
    className: "st12",
    width: 73.8,
    height: 11.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_68_",
    className: "st13",
    d: "M-121.5,4.2h7.9c1.1,0,2,0.9,2,2v18.3h-9.9V4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_67_",
    className: "st13",
    d: "M-185.4,6.2c0-1.1,0.9-2,2-2h6.4c1.1,0,2,0.9,2,2v16.3c0,1.1-0.9,2-2,2h-6.4c-1.1,0-2-0.9-2-2 V6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_66_",
    className: "st14",
    d: "M-182.4-7.3c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v20.5h-14.5V-7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_65_",
    className: "st14",
    d: "M-129.7-7.3c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v20.5h-14.5V-7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_64_",
    className: "st15",
    d: "M-182.2,2.8l14.3-3.6v12.6l-14.3-0.2V2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_63_",
    className: "st16",
    d: "M-182.4,10.4h14.5v14.5h-14.5V10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_62_",
    className: "st17",
    d: "M-182.4,31.2c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v17.8c0,1.1-0.9,2-2,2h-10.5 c-1.1,0-2-0.9-2-2V31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_61_",
    className: "st17",
    d: "M-131,31.2c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v17.8c0,1.1-0.9,2-2,2H-129c-1.1,0-2-0.9-2-2 V31.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_60_",
    x: -129.7,
    y: 10.4,
    className: "st16",
    width: 14.5,
    height: 14.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_59_",
    x: -151.5,
    y: 28.6,
    className: "st5",
    width: 5.5,
    height: 9.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_58_",
    x: -182.4,
    y: 34,
    className: "st18",
    width: 14.5,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_57_",
    x: -131,
    y: 34,
    className: "st18",
    width: 14.5,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_56_",
    x: -167.8,
    y: 42.5,
    className: "st19",
    width: 36.8,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_55_",
    x: -167.8,
    y: 2.3,
    className: "st20",
    width: 38.1,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_54_",
    x: -167.8,
    y: 34,
    className: "st21",
    width: 36.8,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_53_",
    x: -167.8,
    y: 14,
    className: "st22",
    width: 38.1,
    height: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_52_",
    className: "st16",
    d: "M-185.4,24.9h73.8V34c0,1.1-0.9,2-2,2h-69.8c-1.1,0-2-0.9-2-2V24.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_51_",
    className: "st12",
    d: "M-156.5,17.1h14.9c1.7,0,3,1.3,3,3v12.2c0,1.7-1.3,3-3,3h-14.9c-1.7,0-3-1.3-3-3V20.1 C-159.5,18.4-158.2,17.1-156.5,17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_50_",
    className: "st15",
    d: "M-154.9,17.1h-1.7c-1.7,0-3,1.3-3,3v12.2c0,1.7,1.3,3,3,3h1c0.5,0,0.9-0.4,0.9-1l-0.3-12.7 V17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_49_",
    className: "st16",
    d: "M-156.5,21.6h14.9c1.7,0,3,1.3,3,3v11.9c0,1.7-1.3,3-3,3h-14.9c-1.7,0-3-1.3-3-3V24.6 C-159.5,22.9-158.2,21.6-156.5,21.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_48_",
    className: "st23",
    cx: -149.4,
    cy: 28.4,
    rx: 3.9,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_47_",
    className: "st23",
    d: "M-150.3,30.3c0.4-0.7,1.4-0.7,1.8,0l1.8,3.6c0.3,0.7-0.2,1.5-0.9,1.5h-3.6 c-0.7,0-1.2-0.8-0.9-1.5L-150.3,30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    className: "st15",
    d: "M-129.7-4.9l14.5-3.5v8L-129.7,3V-4.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_45_",
    x: -168,
    y: 21.1,
    className: "st15",
    width: 8.4,
    height: 3.8
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_387_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_467_",
    className: "st0",
    d: "M4,26h72c2.2,0,4,1.8,4,4v32c0,2.2-1.8,4-4,4H4c-2.2,0-4-1.8-4-4V30C0,27.8,1.8,26,4,26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_464_",
    className: "st10",
    d: "M8.4,27.7c0-5.5,4.5-10,10-10h42.4c5.5,0,10,4.5,10,10v26.6c0,2.2-1.8,4-4,4H12.4 c-2.2,0-4-1.8-4-4V27.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_461_",
    className: "st11",
    d: "M6.3,13.2c0-5.5,4.5-10,10-10h47.1c5.5,0,10,4.5,10,10v29.8H6.3V13.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_458_",
    x: 3.3,
    y: 30.8,
    className: "st12",
    width: 73.8,
    height: 11.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_455_",
    className: "st13",
    d: "M67.2,13.5h7.9c1.1,0,2,0.9,2,2v18.3h-9.9V13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_452_",
    className: "st13",
    d: "M3.3,15.5c0-1.1,0.9-2,2-2h6.4c1.1,0,2,0.9,2,2v16.3c0,1.1-0.9,2-2,2H5.3c-1.1,0-2-0.9-2-2 V15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_449_",
    className: "st14",
    d: "M6.3,2c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v20.5H6.3V2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_446_",
    className: "st14",
    d: "M58.9,2c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v20.5H58.9V2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_443_",
    className: "st15",
    d: "M6.4,12.1l14.3-3.6v12.6L6.4,21V12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_440_",
    className: "st16",
    d: "M6.3,19.7h14.5v14.5H6.3V19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_437_",
    className: "st17",
    d: "M6.3,40.5c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v17.8c0,1.1-0.9,2-2,2H8.3c-1.1,0-2-0.9-2-2 V40.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_434_",
    className: "st17",
    d: "M57.6,40.5c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v17.8c0,1.1-0.9,2-2,2H59.6 c-1.1,0-2-0.9-2-2V40.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_431_",
    x: 58.9,
    y: 19.7,
    className: "st16",
    width: 14.5,
    height: 14.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_430_",
    x: 37.1,
    y: 37.9,
    className: "st5",
    width: 5.5,
    height: 9.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_427_",
    x: 6.3,
    y: 43.3,
    className: "st18",
    width: 14.5,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_424_",
    x: 57.6,
    y: 43.3,
    className: "st18",
    width: 14.5,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_421_",
    x: 20.8,
    y: 51.8,
    className: "st19",
    width: 36.8,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_418_",
    x: 20.8,
    y: 11.6,
    className: "st20",
    width: 38.1,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_415_",
    x: 20.8,
    y: 43.3,
    className: "st21",
    width: 36.8,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_412_",
    x: 20.8,
    y: 23.3,
    className: "st22",
    width: 38.1,
    height: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_409_",
    className: "st16",
    d: "M3.3,34.2h73.8v9.1c0,1.1-0.9,2-2,2H5.3c-1.1,0-2-0.9-2-2V34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_406_",
    className: "st12",
    d: "M32.1,26.4H47c1.7,0,3,1.3,3,3v12.2c0,1.7-1.3,3-3,3H32.1c-1.7,0-3-1.3-3-3V29.4 C29.1,27.7,30.4,26.4,32.1,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_403_",
    className: "st15",
    d: "M33.7,26.4h-1.7c-1.7,0-3,1.3-3,3v12.2c0,1.7,1.3,3,3,3h1c0.5,0,0.9-0.4,0.9-1L33.7,31V26.4z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_400_",
    className: "st16",
    d: "M32.1,30.9H47c1.7,0,3,1.3,3,3v11.9c0,1.7-1.3,3-3,3H32.1c-1.7,0-3-1.3-3-3V33.9 C29.1,32.2,30.4,30.9,32.1,30.9z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_397_",
    className: "st23",
    cx: 39.2,
    cy: 37.7,
    rx: 3.9,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_394_",
    className: "st23",
    d: "M38.3,39.6c0.4-0.7,1.4-0.7,1.8,0l1.8,3.6c0.3,0.7-0.2,1.5-0.9,1.5h-3.6 c-0.7,0-1.2-0.8-0.9-1.5L38.3,39.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_391_",
    className: "st15",
    d: "M58.9,4.4l14.5-3.5v8l-14.5,3.5V4.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_388_",
    x: 20.6,
    y: 30.4,
    className: "st15",
    width: 8.4,
    height: 3.8
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_144_",
    className: "st24",
    d: "M-198,137.3h72c2.2,0,4,1.8,4,4v32c0,2.2-1.8,4-4,4h-72c-2.2,0-4-1.8-4-4v-32 C-202,139.1-200.3,137.3-198,137.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_143_",
    className: "st25",
    d: "M-192.6,137.5c0-5.5,4.5-10,10-10h42.4c5.5,0,10,4.5,10,10V164c0,2.2-1.8,4-4,4h-54.5 c-2.2,0-4-1.8-4-4V137.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_142_",
    className: "st25",
    d: "M-194.8,122.9c0-5.5,4.5-10,10-10h46.1c5.5,0,10,4.5,10,10v29.8h-66.1V122.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_141_",
    className: "st26",
    d: "M-194.8,150.3c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v17.8c0,1.1-0.9,2-2,2h-10.5 c-1.1,0-2-0.9-2-2V150.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_140_",
    className: "st26",
    d: "M-143.5,150.3c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v17.8c0,1.1-0.9,2-2,2h-10.5 c-1.1,0-2-0.9-2-2V150.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_139_",
    x: -180.2,
    y: 161.5,
    className: "st27",
    width: 36.8,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_138_",
    x: -194.8,
    y: 112.9,
    className: "st28",
    width: 66.1,
    height: 41.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_137_",
    x: -194.8,
    y: 91.3,
    className: "st25",
    width: 65.8,
    height: 25.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_136_",
    x: -194.8,
    y: 149.2,
    className: "st29",
    width: 66.1,
    height: 5.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_135_",
    x: -134.2,
    y: 111.7,
    className: "st29",
    width: 5.6,
    height: 42.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_134_",
    x: -194.8,
    y: 111.7,
    className: "st29",
    width: 5.6,
    height: 42.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_132_",
    x: -194.8,
    y: 120.9,
    className: "st26",
    width: 5.6,
    height: 8.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_80_",
    x: -134.2,
    y: 120.9,
    className: "st26",
    width: 5.6,
    height: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_79_",
    className: "st29",
    d: "M-194.8,90.3c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v16.1h37.5V90.3c0-1.1,0.9-2,2-2h10.5 c1.1,0,2,0.9,2,2v16.1h0.9c1.1,0,2,0.9,2,2v10.5c0,1.1-0.9,2-2,2h-69.1c-1.1,0-2-0.9-2-2v-10.5c0-1.1,0.9-2,2-2h1.7V90.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_78_",
    className: "st30",
    d: "M-125.6,107.5l-46.3,13.4h-24.6c-1.1,0-2-0.9-2-2v-10.5c0-1.1,0.9-2,2-2h1.7v-3l14.5-4.2v7.2 h37.5V90.3c0-1.1,0.9-2,2-2h10.5c1.1,0,2,0.9,2,2v16.1h0.9C-126.6,106.4-125.9,106.8-125.6,107.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_77_",
    x: -189.2,
    y: 134.2,
    className: "st31",
    width: 55,
    height: 15
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_76_",
    className: "st29",
    d: "M-168.3,103.7h14.9c1.7,0,3,1.3,3,3v13.5c0,1.7-1.3,3-3,3h-14.9c-1.7,0-3-1.3-3-3v-13.5 C-171.3,105-170,103.7-168.3,103.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_75_",
    className: "st30",
    d: "M-150.4,110.9l-20.9,6.1v-10.3c0-1.7,1.3-3,3-3h14.9c1.7,0,3,1.3,3,3V110.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_74_",
    className: "st32",
    d: "M-159.3,114.5c1.4-0.5,2.4-1.8,2.4-3.3c0-2-1.8-3.5-3.9-3.5c-2.2,0-3.9,1.6-3.9,3.5 c0,1.5,1,2.7,2.4,3.3l-1.1,2.2c-0.3,0.7,0.2,1.5,0.9,1.5h3.6c0.7,0,1.2-0.8,0.9-1.5L-159.3,114.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_73_",
    x: -142.8,
    y: 104.5,
    className: "st29",
    width: 14.5,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_44_",
    x: -194.8,
    y: 104.5,
    className: "st29",
    width: 14.5,
    height: 1.9
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_4_",
    className: "st33",
    cx: 43.3,
    cy: -166.8,
    rx: 34.7,
    ry: 27.7
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5_",
    className: "st33",
    points: "8.7,-166.8 8.7,-175.4 23.7,-170.9 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_6_",
    className: "st33",
    points: "78,-166.8 78,-174.8 66.2,-174.8 "
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1_",
    className: "st1",
    cx: 43.3,
    cy: -174.8,
    rx: 34.7,
    ry: 27.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_148_",
    className: "st34"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 28.3,
    y: -188.8,
    className: "st34",
    width: 30,
    height: 28
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_149_",
    className: "st35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_150_",
    className: "st36",
    d: "M41.1-187.4c0.9-1.9,3.6-1.9,4.5,0l2.6,5.4c0.4,0.8,1.1,1.3,2,1.4l6,0.7 c2.1,0.2,3,2.9,1.4,4.3l-4.3,3.8c-0.7,0.6-1,1.5-0.8,2.4l1.1,5.6c0.4,2.1-1.8,3.7-3.6,2.7l-5.4-2.9c-0.7-0.4-1.6-0.4-2.4,0 l-5.4,2.9c-1.9,1-4-0.6-3.6-2.7l1.1-5.6c0.2-0.9-0.1-1.8-0.8-2.4l-4.3-3.8c-1.6-1.4-0.8-4.1,1.4-4.3l6-0.7c0.8-0.1,1.6-0.6,2-1.4 L41.1-187.4z"
  })))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_158_",
    className: "st37",
    cx: -315.7,
    cy: 71.3,
    rx: 34.7,
    ry: 27.7
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_157_",
    className: "st37",
    points: "-350.3,71.3 -350.3,62.7 -335.3,67.2 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_154_",
    className: "st37",
    points: "-281,71.3 -281,63.3 -292.8,63.3 "
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_151_",
    className: "st38",
    cx: -315.7,
    cy: 63.3,
    rx: 34.7,
    ry: 27.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_21_"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -330.7,
    y: 49.3,
    width: 30,
    height: 28
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_23_",
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_147_",
    className: "st36",
    d: "M-317.9,50.7c0.9-1.9,3.6-1.9,4.5,0l2.6,5.4c0.4,0.8,1.1,1.3,2,1.4l6,0.7 c2.1,0.2,3,2.9,1.4,4.3l-4.3,3.8c-0.7,0.6-1,1.5-0.8,2.4l1.1,5.6c0.4,2.1-1.8,3.7-3.6,2.7l-5.4-2.9c-0.7-0.4-1.6-0.4-2.4,0 l-5.4,2.9c-1.9,1-4-0.6-3.6-2.7l1.1-5.6c0.2-0.9-0.1-1.8-0.8-2.4l-4.3-3.8c-1.6-1.4-0.8-4.1,1.4-4.3l6-0.7c0.8-0.1,1.6-0.6,2-1.4 L-317.9,50.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChestUnlocked);
export default __webpack_public_path__ + "static/media/chest_unlocked.a0f3b98440d8effc5586b909b990e80f.svg";
export { ForwardRef as ReactComponent };